import gql from 'graphql-tag'

export const Mark_mark = gql`
  fragment Mark_mark on VIMarks {
    id
    text
    secondsAfterStart
  }
`
